import { Text } from '@doda/io-react/common';

/**
 * Titleコンポーネントのプロパティ
 */
interface TitleProps {
  // 表示するテキスト
  text: string;
}

/**
 * タイトルコンポーネント
 * @param {TitleProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} TitleのJSX要素
 */
export const Title = ({ text }: TitleProps) => {
  return (
    <Text as="h2" size="20" color="blue" weight="bold">
      {text}
    </Text>
  );
};
